<template>
  <div
    ref="container"
    :class="b()"
  >
    <div
      ref="filter"
      :class="b('filter')"
    >
      <div :class="b('filter-box')">
        <el-select
          v-model="selectProject"
          :class="b('filter-item')"
          :title="$t('home.todo.todoSource')"
          clearable
          text
          show-text-mode
          clear-search-for-hide
          :select-dropdown-option="{
            minWidth: 200
          }"
          :placeholder="$t('navbar.all')"
          @change="onChange"
        >
          <el-option
            v-for="item of projectOptions"
            :key="item.value"
            :value="item.value"
            :label="item.name"
          />
        </el-select>
        <el-button
          v-show="!showAddTodoInput && !isPreviewMode"
          :class="b('add-button')"
          type="text"
          @click="showTodoForInput"
        >
          <em class="zkicon icontianjia"></em>
          {{ $t('home.todo.addTodo') }}
        </el-button>
      </div>
      <Sort
        v-model="settings.orderBy"
        :groups="orderByList"
        :placeholder="$t('kanbans.soft')"
        size="small"
        @change="onSortChange"
      />
    </div>
    <div
      v-show="showAddTodoInput"
      ref="addTodoInput"
      :class="b('add-todo-container')"
    >
      <AddTodoInput
        ref="child"
        @cancel="showTodoForInput"
        @submit="submitTodoForInput"
        @show:todoDialog="addTodo"
      />
    </div>
    <EmptySwitchBox
      :empty="false"
      :loading="firstLoading"
      :image="require('@/assets/widget/assigned-empty.png')"
      :desc="$t('home.emptyData')"
    >
      <vxe-table
        ref="table"
        show-overflow
        :tooltip-config="{contentMethod: () => ''}"
        :class="[b('table'), 'zk-el-table', b(`table-drag-${widget.i}`)]"
        :data="tableGroup"
        style="width: 100%"
        auto-resize
        :height="tableHeight"
        :scroll-y="{enabled: true}"
        :resizable-config="{ minWidth: 50 }"
        :span-method="spanMethod"
        row-id="id"
        :show-header="false"
        :expand-config="expandConfig"
        trigger="row"
        border="none"
        :resizable="true"
        :row-class-name="draggableRowClass"
        :cell-class-name="draggableCellClass"
        @toggle-row-expand="toggleShowChildren"
      >
        <vxe-table-column
          key="state"
          field="state"
          :width="120"
        >
        </vxe-table-column>
        <vxe-table-column
          key="name"
          field="name"
          type="expand"
          min-width="200"
        >
          <template #default="{row: {groupName}, row }">
            <div
              :class="b('project-name')"
            >
              <span>{{ groupName }}</span>
              <span :class="b('point')">({{ row.children.length }})</span>
            </div>
          </template>

          <template #content="{row: group}">
            <div
              v-show="!dragging"
            >
              <vxe-table
                auto-resize
                :class="[b('table'), 'zk-el-table']"
                :data="group.children"
                :show-header="false"
                highlight-hover-row
                border="none"
                style="width: 100%"
                :max-height="1000"
                :scroll-y="{gt: 100}"
                :row-class-name="draggableDropRowClass"
                :cell-class-name="getCellClassName"
                @cell-click="openIssueDialog"
              >
                <vxe-table-column
                  key="state"
                  field="state"
                  :width="120"
                >
                  <template #default="{row}">
                    <div :class="b('column-status')">
                      <em
                        :class="['zkicon iconicon_yidong', b('icon-daily-move')]"
                      ></em>
                      <div
                        v-if="row.issueType && row.issueType.code === 'subtask'"
                        :class="[b('status-container'), 'ignore-drag']"
                      >
                        <span
                          :class="[b('check-status-todo')]"
                          @click="handleCommandChangeState(4, row)"
                        >
                          <!-- <div
                            :class="b('dropdown-status')"
                          >
                          </div> -->
                          <em :class="['zkicon','iconweiwancheng1',b('dropdown-status')]" />
                        </span>
                        <div
                          v-overflow-tooltip="getStatusName(row)"
                          :class="[b('status-name'), 'text-ellipsis', b(`status-font-${getStateCategory(row)}`), !isPreviewMode && 'click-cursor']"
                        >
                          {{ getStatusName(row) }}
                        </div>
                      </div>
                      <div
                        v-else
                      >
                        <el-popover
                          :ref="`todoPopover${row.id}`"
                          :popper-class="b('todo-status')"
                          trigger="click"
                          :tabindex="row.id"
                          :disabled="isPreviewMode || isProjectInnerCollaboratorButNotAdmin(row)"
                          :visible-arrow="false"
                          @show="getTodoNextState(row)"
                          @close="clearStateList"
                        >
                          <ul
                            :class="b('status-list')"
                          >
                            <template v-if="showStateList">
                              <li
                                :class="b('status-loading')"
                              >
                                <em class="el-icon-loading"></em>
                              </li>
                            </template>
                            <template v-else>
                              <li
                                v-for="item in currentStateList"
                                :key="item.stateId"
                              >
                                <div
                                  v-overflow-tooltip="item.stateName"
                                  :class="[b('status-item'), 'text-ellipsis']"
                                  @click="handleCommandChangeState(item, row)"
                                >
                                  {{ item.stateName }}
                                </div>
                                <el-divider v-if="item.lastOne"></el-divider>
                              </li>
                              <li
                                v-if="!showStateList && currentStateList.length === 0"
                                :class="[b('status-placeholder')]"
                              >
                                <span>{{ $t('home.todo.noStatusChange') }}</span>
                              </li>
                            </template>
                          </ul>
                          <div
                            slot="reference"
                            :class="b('status-container')"
                          >
                            <em :class="['zkicon','iconweiwancheng1',b('dropdown-status')]" />
                            <div
                              v-overflow-tooltip="getStatusName(row, true)"
                              :class="[b('status-name'), 'text-ellipsis', b(`status-font-${getStateCategory(row)}`), !isPreviewMode && 'click-cursor']"
                            >
                              {{ getStatusName(row) }}
                            </div>
                          </div>
                        </el-popover>
                      </div>
                    </div>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  key="name"
                  field="name"
                  min-width="200"
                  class-name="issue-name"
                >
                  <template #default="{ row: {name, issueType, entityType, parentSummary, parentId, parentIssueType} }">
                    <div
                      v-if="entityType === 'Issue' && parentId"
                      :class="[b('title'), !isPreviewMode && 'click-cursor', b('name-container')]"
                    >
                      <div
                        :class="b('parent-name')"
                      >
                        <ImageOrIcon
                          v-if="parentIssueType"
                          :src="parentIssueType.iconUrl"
                          :size="16"
                          symbol
                        />
                        <ImageOrIcon
                          v-else
                          src="icongongzuoleixing-daiban"
                          :size="16"
                          :symbol="true"
                        />
                        <div
                          class="text-ellipsis"
                        >
                          {{ parentSummary }}
                        </div>
                      </div>
                      <div
                        :class="b('subtask-name')"
                      >
                        <em class="zkicon iconcengji" />
                        <ImageOrIcon
                          v-if="issueType"
                          :src="issueType.iconUrl"
                          :size="16"
                          symbol
                        />
                        <ImageOrIcon
                          v-else
                          src="icongongzuoleixing-daiban"
                          :size="16"
                          :symbol="true"
                        />
                        <div
                          v-overflow-tooltip="name"
                          class="text-ellipsis"
                        >
                          {{ name }}
                        </div>
                      </div>
                    </div>
                    <div
                      v-else
                      :class="[b('title'), !isPreviewMode && 'click-cursor']"
                    >
                      <ImageOrIcon
                        v-if="issueType"
                        :src="issueType.iconUrl"
                        :size="16"
                        symbol
                      />
                      <ImageOrIcon
                        v-else
                        src="icongongzuoleixing-daiban"
                        :size="16"
                        :symbol="true"
                      />
                      <div
                        v-overflow-tooltip="name"
                        class="text-ellipsis"
                      >
                        {{ name }}
                      </div>
                    </div>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  key="priority"
                  field="priority"
                  :width="50"
                >
                  <template #default="{row}">
                    <el-tooltip
                      v-if="row.entityType === 'TodoList' || row.issueType.code !== 'subtask'"
                      :content="`${$t('home.todo.priority')} : ${
                        getPriority(row).name || $t('home.todo.unset')
                      }`"
                    >
                      <PriorityDropdown
                        :key="row.id"
                        :value="getPriority(row).id"
                        :default-color="getPriority(row).color"
                        :prioritys="priorityList"
                        :disabled="isPreviewMode || isProjectInnerCollaboratorButNotAdmin(row)"
                        @change="onChangeTaskPriority($event, row)"
                      />
                    </el-tooltip>
                  </template>
                </vxe-table-column>
                <vxe-table-column
                  key="dueDate"
                  field="dueDate"
                  :width="180"
                >
                  <template #default="{row: {dueDate}, row}">
                    <el-tooltip>
                      <template #content>
                        <span>{{ $t("home.todo.dueDate") }} :</span>
                        <span v-if="dueDate">
                          {{ dueDate | formatCalendarDate({ sameDay: '[today] HH:mm' }) }}
                        </span>
                        <span v-else>
                          {{ $t('home.todo.wu') }}
                        </span>
                      </template>
                      <ZkDueDate
                        :key="row.id"
                        v-model="row.dueDate"
                        clearable
                        clear-fixed
                        :class="[b('date'), 'ignore-drag']"
                        type="datetime"
                        default-time="18:00:00"
                        :format="$i18n.dateFormat.dateTime"
                        value-format="timestamp"
                        :empty-text="$t('issue.Unknow')"
                        :cleartext="$t('button.clear')"
                        :picker-options="pickerConfig(row)"
                        :disabled="isPreviewMode || isProjectInnerCollaboratorButNotAdmin(row)"
                        @change="onChangeTaskDueDate($event, row)"
                      >
                        <template #text>
                          <span
                            v-overdue-time:[row]="
                              {
                                check: checkIsDue,
                                className: b('is-due')
                              }
                            "
                            :class="b('due-time')"
                          >
                            {{ dueDate | formatCalendarDate({ sameDay: '[today] HH:mm' }) }}
                          </span>
                        </template>
                      </ZkDueDate>
                    </el-tooltip>
                  </template>
                </vxe-table-column>
              </vxe-table>
            </div>
            <div
              v-show="dragging"
              :data-group="group.id"
              :style="`${dragging ? `width: 100%;height: 80px;` : ''}`"
              :class="[b('dragging-placeholder'), group.id === 'overDueList' ? '' : `todoDropzone-${widget.i} ${b('allow')}`]"
            >
              <span v-show="group.id === 'overDueList'">
                <em
                  class="zkicon iconjinzhi"
                />
                {{ $t('home.todo.noDrag') }}
              </span>
              <span
                v-show="group.id !== 'overDueList'"
                :class="b('allow')"
              >
                {{ $t('home.todo.canDrag') }}
              </span>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          key="priority"
          field="priority"
          :width="50"
        >
        </vxe-table-column>
        <vxe-table-column
          key="dueDate"
          field="dueDate"
          :width="180"
        >
        </vxe-table-column>
      </vxe-table>
    </EmptySwitchBox>
    <AddTodoDialog
      :id="currentTodo"
      :default-todo="defaultTodo"
      :show="showAddTodoDialog"
      :is-preview-mode="isPreviewMode"
      @close="closeTodo"
      @cancel="closeTodo"
      @submit="submitTodo"
    />
  </div>
</template>

<script>
import widgetMixin from '../Widget/widgetMixin';
import widgetConfigMixin from '../Config/widgetConfigMixin';
import theme from '@zk/theme/lib/variables.scss';
import { isEqual, isNil, debounce, groupBy } from 'lodash';
import { addResizeListener, removeResizeListener } from 'zk-ui';
import { moveOfEvent, setStyle } from '@zk/framework-vue';
import {
  getTodoList,
  getTodoProjectList,
  updateTodoStatus,
  getTodoNextState,
  updateIssue,
  getTodoPriorityList,
  updatedTodoPriority,
  updatedTodoDueDate,
  syncIssueForTodoList
} from '@/api/home';
import dayjs from 'dayjs';
import AddTodoDialog from '../Dialog/AddTodo';
import AddTodoInput from '../components/AddTodoInput';
import PriorityDropdown from 'common-module/src/components/PriorityDropdown';
import interact from 'interactjs';
import ZkDueDate from 'common-module/src/components/DueDate';

const ORDER_BY = [{
  i18nKey: '${issue#field#priority}', value: 'priority'
}, {
  i18nKey: '${issue#field#dueDate}', value: 'dueDate'
}];

export default {
  name: 'TodoList',
  components: {
    AddTodoDialog,
    AddTodoInput,
    PriorityDropdown,
    ZkDueDate
  },
  mixins: [widgetMixin, widgetConfigMixin],
  widget: {
    wTimes: 5,
    hTimes: 3,
    minW: 3,
    minH: 2,
    maxW: 10,
    configComponent: () => import('../Config/TodoListWidgetConfig'),
    supportSilent: true
  },
  // 子任务ID的issue
  currentIssueDialogId: null,
  props: {
    dashboard: {
      type: [String, Number],
      required: false
    }
  },
  data() {
    return {
      bemNS: theme.bemNS,
      tableHeight: 'auto',
      todoList: null,
      projectOptions: [],
      selectProject: '',
      dragging: false,
      currentStateList: [],
      showStateList: false,
      priorityList: [],
      showAddTodoDialog: false,
      currentTodo: null,
      showAddTodoInput: false,
      defaultTodo: null,
      oldOrderBy: null,
      tableGroup: [],
      tableExpandStatus: {},
      expandConfig: {},
      cloneGhostElement: null
    };
  },
  computed: {
    orderByList() {
      return this.$tr ? ORDER_BY.map(item => ({ ...item, text: this.$tr(item.i18nKey) })) : [];
    }
  },
  watch: {
    showAddTodoInput() {
      this.$nextTick(() => this.onResize());
    }
  },
  async created() {
    this.dropDownPriorityList();
    const res = await getTodoProjectList();
    this.projectOptions = res.list;
    //飞书转代办，跳转工作台时，修改当前项目为个人代办
    const { setting, dashboardId } = this.$route.query;
    if (setting === 'selfTodo' && res.list[0] && this.dashboard === Number(dashboardId)) {
      this.$track.send('TodoList_ShowDetails', {
        Path: '飞书转代办'
      }, true);
      this.onChange(res.list[0].value);
    }
  },
  async mounted() {
    addResizeListener(this.$el, this.onResize);
    this.eventBus.$on('issue:submit', this.loadData);
    this.eventBus.$on('issue:loadIssueList', this.loadData);
    if (!this.isPreviewMode) {
      this.initDraggable();
    }
  },
  beforeDestroy() {
    removeResizeListener(this.$el, this.onResize);
    this.eventBus.$off('issue:submit', this.loadData);
    this.eventBus.$off('issue:loadIssueList', this.loadData);
    if (this.cloneGhostElement) {
      this.cloneGhostElement.remove();
      this.dragging = false;
      document.documentElement.classList.remove('is-dragging');
    }
    if (this.interact) {
      this.interact.unset();
      this.interactDraggable.unset();

      this.interact = null;
      this.interactDraggable = null;
    }
  },
  methods: {
    isNil,
    onResize() {
      const height = this.$el.getBoundingClientRect().height || 405;
      const filterHeight = this.$refs.filter.getBoundingClientRect().height || 36;
      const addTodoInputHeight = this.$refs.addTodoInput.getBoundingClientRect().height || 0;
      this.tableHeight = `${height - filterHeight - addTodoInputHeight - 11}px`;
    },
    isProjectInnerCollaboratorButNotAdmin(row) {
      return this.$store.getters['user/isProjectInnerCollaboratorButNotAdminWithProject'](row.project?.id);
    },
    async loadData(issueId) {
      if (this.firstLoading) {
        this.initUserStatus();
      }
      const { fields = [], orderBy = { desc: true, orderBy: 'dueDate' } } = this.settings;
      const params = {
        homeWidgetId: this.widget.i,
        projectId: this.selectProject,
        showFileCodeList: fields.filter(f => f.show).map(f => f.key),
        queryFilter: {
          conditions: [
            {}
          ],
          orderBy: [{ field: orderBy.orderBy, desc: orderBy.desc }]
        }
      };
      if (typeof issueId === 'number') {
        await syncIssueForTodoList(issueId);
      }
      this.todoList = await getTodoList(params);
      this.setTableGroup();
    },
    onChange(v) {
      this.selectProject = v;
      this.userHabit();
      this.$track.send('TodoList_Filter', {
        FilterType: '待办来源',
        TabType: '我的待办'
      }, true);
      this.$track.send('Dashboard_WidgetFilter', {
        Widget_Name: '待办清单',
        Filter_Type: '待办来源',
        TabType: '我的待办'
      }, true);
    },
    onSortChange(v) {
      if (isEqual(this.oldOrderBy, v)) {
        return;
      }
      this.oldOrderBy = v;
      this.updateSettings({ orderBy: { ...v } });

      this.$track.send('TodoList_Sort', {
        FilterType: v?.orderBy === 'dueDate' ? '截止时间' : '优先级',
        TabType: '我的待办'
      }, true);
    },
    getTableLabel(key) {
      return this.settings.fields.find(f => f.key === key && f.show);
    },
    openIssueDialog({ row, column }) {
      if (this.isPreviewMode) {
        return;
      }
      if (column.property !== 'name') {
        return;
      }
      const { entityType } = row;
      if (entityType === 'TodoList') {
        this.currentTodo = row;
        this.onShowTodoDialog(row);
        this.$track.send('TodoList_ShowDetails', { path: '查看时展开详情' }, true);
        return;
      }
      const { issueType: { code } = {}, id } = row;
      if (!id) {
        return;
      }
      this.$options.currentIssueDialogId = id;
      this.eventBus.$emit('global:openIssueDialog', code, id);
    },
    spanMethod({ column }) {
      // 加1 是由于有一列是 expand;
      return {
        // eslint-disable-next-line
        rowspan: 1,
        // eslint-disable-next-line
        colspan: column.property === 'name' ? 4 : 0
      };
    },
    toggleShowChildren({ row, expanded }) {
      this.tableExpandStatus[row.id] = expanded;
      this.userHabit();
    },
    draggableRowClass() {
      return 'group';
    },
    draggableDropRowClass({ row }) {
      if (this.isPreviewMode || this.isProjectInnerCollaboratorButNotAdmin(row)) {
        return '';
      }
      return `drag-drop-${this.widget.i} drag-item-${row.id} drag-group-${row.group}`;
    },
    initDraggable() {
      this.interact = interact(`.todoDropzone-${this.widget.i}`).dropzone({
        // only accept elements matching this CSS selector
        accept: `.drag-drop-${this.widget.i}`,
        overlap: 'pointer',
        ondragenter: (e) => {
          const target = e.target;
          target.classList.add('zk-todo-list__current-todo-dropzone');
        },
        ondragleave: (e) => {
          const target = e.target;
          target.classList.remove('zk-todo-list__current-todo-dropzone');
        },
        ondrop: e => {
          const { interaction: { metadata: { from, item } = {} }, currentTarget } = e;
          if (!from || !item) {
            return;
          }
          const { dataset } = currentTarget;
          const toGroupId = dataset.group;
          const fromGroupId = from;

          if (toGroupId && toGroupId !== fromGroupId) {
            this.changeTodoGroupType(item, fromGroupId, toGroupId);
          }
        }
      });
      interact.dynamicDrop(true);
      this.initDraggableEvent();
    },
    initDraggableEvent() {
      this.interactDraggable = interact(`.drag-drop-${this.widget.i}`);
      this.interactDraggable.ignoreFrom('.el-dropdown, .ignore-drag');
      this.interactDraggable.draggable({
        inertia: true,
        manualStart: true,
        modifiers: [
          interact.modifiers.restrictRect({
            restriction: document.querySelector(`.zk-todo-list__table-drag-${this.widget.i} .vxe-table--body-wrapper`)
          })
        ],
        autoScroll: {
          container: document.querySelector(`.zk-todo-list__table-drag-${this.widget.i} .vxe-table--body-wrapper`),
          margin: 100
        },
        listeners: {
          start: (e) => {
            document.documentElement.classList.add('is-dragging');
            // 触发click-outside，关闭dropdown等
            const mouseup = new MouseEvent('mouseup', {
              bubbles: true,
              cancelable: true,
              view: window
            });
            requestAnimationFrame(() => document.dispatchEvent(mouseup));
            try {
              if (document.selection) {
                this.$nextTick(() => document.selection.empty());
              } else {
                requestAnimationFrame(() => {
                  window.getSelection().removeAllRanges();
                });
              }

              const from = e.interaction?.metadata?.from;
              if (!from) {
                return;
              }
              this.setThreeRowExpand();

              this.dragging = true;
            } catch (err) {
              console.warn('remove selection error', err);
            }
          },
          // 移动元素
          move: e => moveOfEvent(e),
          // 结束拖拽
          end: e => {
            const { interaction: { metadata = {} } } = e;
            if (metadata.ghost) {
              metadata.ghost.remove();
            }
            this.setTableExpandOldStatus();
            this.dragging = false;
            document.documentElement.classList.remove('is-dragging');
          }
        }
      }).on('down', e => {
        // 防止从别的地方拖拽，只有先点击该元素，再move到元素中才触发拖拽
        if (e.button === 0) {
          e.interaction.triggerOnMouseDown = true;
          // 防止进入点击
          e.preventDefault();
        }
      }).on('move', e => {
        const { interaction, interactable, currentTarget } = e;
        // 如果鼠标在按住的同时被移动，并且未开始交互则克隆节点用于拖拽
        if (interaction.triggerOnMouseDown && interaction.pointerIsDown && !interaction.interacting()) {
          e.interaction.triggerOnMouseDown = false;
          const { group, itemId } = this.getCurrentRowId(currentTarget);
          const s = this.todoList[group]?.find(item => item.id === Number(itemId));
          if (!s) {
            return;
          }

          const from = group;
          this.cloneGhostElement = this.createDragGhost(currentTarget);
          interaction.metadata = {
            ghost: this.cloneGhostElement,
            from,
            item: this.todoList[group].find(item => item.id === Number(itemId)),
            to: null
          };

          // 开始克隆元素的拖拽交互
          interaction.start({ name: 'drag' }, interactable, this.cloneGhostElement);
        }
      });
    },
    /**
     * 创建拖拽元素（脱离文档）
     * @param target
     * @returns {ActiveX.IXMLDOMNode | Node}
     */
    createDragGhost(target) {
      const rect = interact.getElementClientRect(target);
      const clone = target.cloneNode(true);
      clone.classList.add('is-draggable-clone-home-table');
      setStyle(clone, {
        zIndex: 2000,
        position: 'fixed',
        width: `${rect.width}px`,
        height: `${rect.height}px`,
        top: `${rect.top}px`,
        left: `${rect.left}px`,
        touchAction: 'none'
      });
      document.body.appendChild(clone);
      return clone;
    },
    // 拖拽时，展开2，3，4行
    setThreeRowExpand() {
      this.$options.copyTableExpandStatus = this.tableExpandStatus;
      this.$refs.table.setRowExpand(
        [this.tableGroup[1], this.tableGroup[2], this.tableGroup[3]],
        true
      );
    },
    // 拖拽后，还原展开状态
    setTableExpandOldStatus() {
      this.tableExpandStatus = this.$options.copyTableExpandStatus;
      let keys = Object.keys(this.tableExpandStatus);
      const len = this.tableGroup.length;
      // console.log(len);
      if (len < 4) {
        // 由于存在 overDuelist 可能被删除的情况，所以长度时变化的；
        keys = keys.filter(item => item === 'overDueList');
      }
      keys.forEach((key, i) => {
        this.$refs.table.setRowExpand([this.tableGroup[i]], this.tableExpandStatus[key]);
      });
    },
    getCurrentRowId(el) {
      const classList = Array.from(el.classList);
      if (classList.length < 1) {
        return {};
      }
      const itemId = classList.find(elClass => elClass?.includes('drag-item-'))?.replace('drag-item-', '');
      const group = classList.find(elClass => elClass?.includes('drag-group-'))?.replace('drag-group-', '');
      return {
        itemId,
        group
      };
    },
    getStatusName(row, isTips) {
      if (row.entityType === 'TodoList') {
        return isTips ? `${this.$t('home.todo.status')}: ${row.todoState?.name}` : row.todoState?.name;
      }

      return isTips ? `${this.$t('home.todo.status')}: ${row.state?.name}` : row.state?.name;
    },
    getStateCategory(row) {
      if (row.entityType === 'TodoList') {
        return row?.todoState?.stateCategory;
      }
      return row.state?.stateCategory;
    },
    async changeTodoGroupType(item, fromGroupId, toGroupId) {
      const now = new Date();
      let today, last7Day, last14Day;
      switch (toGroupId) {
        case 'todayDueList':
          today = dayjs(now).hour(18).minute(0).second(0);
          this.onChangeTaskDueDate(today.valueOf(), item);
          break;
        case 'after7dayDueList':
          last7Day = dayjs(now).add(7, 'day').hour(18).minute(0).second(0);
          this.onChangeTaskDueDate(last7Day.valueOf(), item);
          break;
        case 'laterDueList':
          last14Day = dayjs(now).add(14, 'day').hour(18).minute(0).second(0);
          this.onChangeTaskDueDate(last14Day.valueOf(), item);
          break;
        default:
          break;
      }
    },
    handleCommandChangeState: debounce(async function(command, row) {
      if (this.isPreviewMode) {
        return;
      }
      let id, status;
      if (row.entityType === 'TodoList') {
        id = row.id;
        status = command.stateId;
        await updateTodoStatus({
          id,
          status
        });
        this.updateTodoItemStatus(row, command);
        this.$track.send('TodoList_DoneTodo', {}, true);
      } else if (row.issueType.code === 'subtask') {
        id = row.id;
        await this.getTodoNextState(row);
        const find = this.currentStateList.find(item => item.stateCategory === command);
        status = find.stateId;
        await updateIssue(id, { status });
        this.updateTodoItemStatus(row, find);
        this.clearStateList();
      } else {
        id = row.id;
        status = command.stateId;
        await updateIssue(id, { status });
        this.updateTodoItemStatus(row, command);
      }
      // 埋点
      this.$track.send('TodoList_Update', {
        Field_Name: '状态',
        Issue_Type: row.entityType === 'TodoList' ? '个人待办' :
          row.entityType === 'subtask' ? '子任务' : '工作'
      }, true);
      // todo || issue (当为子任务时，不用关闭popover)
      if (!row.issueType || row.issueType.code !== 'subtask') {
        this.$refs[`todoPopover${row.id}`].doClose();
      }
      this.$message.success(this.$t('home.todo.updateSuccess'));
    }, 100),
    updateTodoItemStatus(row, state) {
      const keys = Object.keys(this.todoList);
      const stateKey = row.entityType === 'TodoList' ? 'todoState' : 'state';
      let i = -1, key;
      keys.forEach(inlineKey => {
        const inlineIndex = this.todoList[inlineKey].findIndex(i => i.id === row.id);
        if (inlineIndex > -1) {
          i = inlineIndex;
          key = inlineKey;
        }
      });
      // 当处于已完成时，剔除此条，并更新列表
      if (i > -1 && state.stateCategory === 4) {
        this.todoList[key].splice(i, 1);
        this.setTableGroup();
        return;
      }
      // 由于后端接口数据是异步的，所以需要手动更新状态
      if (i > -1 && state.stateCategory !== 4) {
        this.$set(this.todoList[key][i], stateKey, {
          ...this.todoList[key][i][stateKey],
          ...state,
          id: state.stateId,
          name: state.stateName,
          stateCategory: state.stateCategory
        });
        this.setTableGroup();
      }
    },
    clearStateList() {
      this.currentStateList = [];
      this.showStateList = false;
    },
    async getTodoNextState(row) {
      this.showStateList = true;
      const params = {
        entityId: row.id,
        entityType: row.entityType,
        state: row.entityType === 'TodoList' ? row.todoState.stateCategory : row.state.id
      };

      const list = await getTodoNextState(params);
      const listMap = groupBy(list, 'stateCategory');
      // 给每个组的最后一个加上标志
      this.currentStateList = Object.keys(listMap).reduce((a, c) => {
        if (listMap[c].length > 0) {
          listMap[c][listMap[c].length - 1].lastOne = true;
        }
        return [
          ...a,
          ...listMap[c]
        ];
      }, []);
      this.showStateList = false;
    },
    checkIsDue(row) {
      const { dueDate: due } = row;
      const b = dayjs().isAfter(due);
      let b2 = true;
      // 已完成的状态，不显示标红的截止日期
      if (row.entityType === 'TodoList') {
        b2 = row.todoState.stateCategory !== 4;
      } else {
        b2 = row.stateCategory !== 4;
      }
      return b && b2;
    },
    draggableCellClass() {
      return this.b('cell-all-row-width');
    },
    /**
     * 修改父任务优先级
     * @param id 优先级Id
     * @returns {Promise<void>}
     */
    async onChangeTaskPriority(id, row) {
      this.reportTrackPriority(row);
      if (row.entityType === 'TodoList') {
        await updatedTodoPriority(row.id, id);
        await this.loadData();
        this.$message.success(this.$t('home.todo.updateSuccess'));
        return;
      }

      await updateIssue(row.id, { priority: id });
      await this.loadData(row.id);
      this.$message.success(this.$t('home.todo.updateSuccess'));
    },
    async dropDownPriorityList() {
      const array = await getTodoPriorityList();
      this.priorityList = array || [];
      // this.priorityList = array ? [{ id: null, color: '#d7d7d7', name: this.$t('home.todo.wu') }, ...array] : [];
    },
    showTodoForInput() {
      this.showAddTodoInput = !this.showAddTodoInput;
      if (!this.showAddTodoInput) {
        this.defaultTodo = null;
      }
      this.$nextTick(() => {
        this.$refs.child.addTodoInputFocus();
        this.$refs.child.setDefaultTime();
      });
    },
    submitTodoForInput() {
      this.showAddTodoInput = false;
      this.loadData();
    },
    addTodo(defaultTodo = null) {
      this.defaultTodo = {
        ...defaultTodo
      };
      this.showAddTodoInput = false;
      this.showAddTodoDialog = true;
      this.$track.send('TodoList_ShowDetails', { path: '添加时展开详情' }, true);
    },
    onShowTodoDialog(todo) {
      this.currentTodo = todo.id;
      this.addTodo();
    },
    closeTodo() {
      this.currentTodo = null;
      this.showAddTodoDialog = false;
    },
    submitTodo() {
      this.loadData();
      this.currentTodo = null;
      this.showAddTodoDialog = false;
    },

    dayFormat(date) {
      return dayjs(date).isValid() ? dayjs(date).format('HH:mm:ss') : null;
    },
    /* 截止时间禁选配置 */
    pickerConfig(row) {
      if (!row.startDate){
        return;
      }

      const MAX_TIME = '23:59:59';
      const MIN_TIME = '00:00:00';
      const minTime = this.dayFormat(row.startDate) || MIN_TIME;
      const isSameDay = dayjs(row.dueDate).isSame(dayjs(row.startDate), 'day');
      const startDateVo = dayjs(row.startDate).startOf('day');
      return {
        disabledDate: time => startDateVo.isValid() ? dayjs(time).isBefore(startDateVo) : false,
        selectableRange: isSameDay ? `${minTime} - ${MAX_TIME}` : []
      };
    },
    /**
     * 修改截止时间
     * @param value 截止时间
     * @returns {Promise<void>}
     */
    async onChangeTaskDueDate(value, row) {
      this.reportTrackTime(value, row);
      if (row.entityType === 'TodoList') {
        await updatedTodoDueDate(row.id, value);
        await this.loadData();
        this.$message.success(this.$t('home.todo.updateSuccess'));
        return;
      }
      const params = {
        dueDate: value,
        startDate: typeof row.startDate === 'number' && value > row.startDate ?
          row.startDate : null
      };
      await updateIssue(row.id, params);
      await this.loadData(row.id);
      this.$message.success(this.$t('home.todo.updateSuccess'));
    },
    getPriority(row) {
      return row.priority || {};
    },
    setTableGroup() {
      const groupList = [];
      const list = this.todoList;
      const groupMap = {
        overDueList: this.$t('home.todo.overDue'),
        todayDueList: this.$t('home.todo.todayDue'),
        after7dayDueList: this.$t('home.todo.after7dayDue'),
        laterDueList: this.$t('home.todo.laterDue')
      };
      if (this.todoList?.overDueList?.length < 1) {
        Reflect.deleteProperty(groupMap, 'overDueList');
      }
      if (this.todoList) {
        Object.keys(groupMap).forEach((group) => {
          groupList.push({
            id: group,
            projectId: group,
            isGroup: true,
            groupName: groupMap[group],
            children: list[group].map(item => ({
              ...item,
              group
            }))
          });
        });
      }
      this.tableGroup = groupList;
      this.$nextTick(() => {
        this.initDraggableEvent();
      });
    },
    initUserStatus() {
      if (this.settings.todoList) {
        this.selectProject = this.settings.todoList.selectProject;
        this.tableExpandStatus = this.settings.todoList.tableExpandStatus;
        const keys = Object.keys(this.tableExpandStatus);
        this.expandConfig = {
          iconOpen: 'iconzhankai_shi zkicon',
          iconClose: 'iconxiangyouzhankai zkicon',
          trigger: 'row',
          reserve: true,
          expandRowKeys: keys.filter(key => this.tableExpandStatus[key])
        };
        return;
      }

      this.tableExpandStatus = {
        overDueList: true,
        todayDueList: true,
        after7dayDueList: false,
        laterDueList: false
      };
      const keys = Object.keys(this.tableExpandStatus);
      this.expandConfig = {
        iconOpen: 'iconzhankai_shi zkicon',
        iconClose: 'iconxiangyouzhankai zkicon',
        trigger: 'row',
        reserve: true,
        expandRowKeys: keys.filter(key => this.tableExpandStatus[key])
      };
    },
    userHabit(){
      const params = {
        selectProject: this.selectProject,
        tableExpandStatus: this.tableExpandStatus
      };
      this.updateSettings({ todoList: params });
    },
    getCellClassName() {
      return this.isPreviewMode ? 'cursor-default' : '';
    },
    reportTrackTime(value) {
      let deadline = '';
      const now = dayjs().startOf('day');
      const time = dayjs(value).startOf('day');
      if (!time.isValid()) {
        deadline = '清空';
      } else {
        const days = time.diff(dayjs(now), 'day');
        deadline = days < 0 ? '逾期时间' : days === 0 ? '今天' :
          days > 0 && days <= 7 ? '未来7天' : '7天后';
      }

      this.$track.send('TodoList_Update', {
        Field_Name: '截止时间',
        Deadline_Time: deadline
      }, true);
    },
    reportTrackPriority(row) {
      this.$track.send('TodoList_Update', {
        Field_Name: '优先级',
        Issue_Type: row.entityType === 'TodoList' ? '个人待办' :
          row.entityType === 'subtask' ? '子任务' : '工作'
      }, true);
    }
  }
};
</script>

<style lang="scss" scoped>
@mixin stateColor($bg, $color) {
  background-color: $bg;
  color: $color;
}
@include b(todo-list) {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  @include e(filter) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  @include e(filter-box) {
    display: flex;
    align-items: center;
  }
  @include e(filter-item) {
    max-width: 200px;
    margin-right: var(--p-default);
  }
  @include e(table) {
    &:before {
      background: transparent;
    }
    ::v-deep {
      td {
        border-bottom: 0;
      }
      th > .vxe-cell, td > .vxe-cell {
        line-height: 26px;
        display: flex;
        align-items: center;
      }
      .vxe-body--column {
        padding: 7px;
      }
      @include icon {
        margin-right: var(--m-mini);
      }
    }
  }
  @include e(title) {
    display: flex;
    align-items: center;
    overflow: hidden;
    flex: 1;
    svg {
      min-width: 16px;
      margin-right: var(--m-small);
    }
  }
  @include e(project-name) {
    color: var(--font-color-1);
    height: 25px;
    font-size: var(--size-font-6);
    font-weight: var(--weight-font-Blod);
    line-height: 22px;
    cursor: pointer;
    user-select: none;
    @include e(point) {
      margin-left: var(--m-mini);
    }
  }

  // 拖拽样式
  @include e(dragging-placeholder) {
    border-radius: var(--radius-mini);
    border: 2px dashed #999999;
    background: #F5F5F5;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @include e(dropdown-status) {
    color:var(--color-border-1);
    cursor: pointer;
    margin-right: 0!important;
  }
  @include e(check-status-todo) {
    cursor: pointer;
    .iconwancheng {
      color: #B5B5B5;
    }
  }
  @include e(allow) {
    background: #F6F9FF;
    border-color: #3F71DE;
  }
  @include e(current-todo-dropzone) {
    background: #F7FFF7;
    border-color: #0EB83A;
  }
  ::v-deep {
    @include e(is-due) {
      color: #EB261A;
      .icontime {
        color: #EB261A;
      }
    }
  }
  @include e(column-status) {
    display: flex;
    align-items: center;
    .iconicon_yidong {
      transform: rotate(90deg);
      // margin-left: -5px;
      margin-right:  var(--m-small);
      cursor: move;
      // color: #fff;
      color: transparent;
    }
    .icon-daily-move {
      color: rgba(0, 0, 0, 0.04);
    }
  }
  @include e(status-container) {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  @include e(status-font-2) {
    margin-left: 2px;
    color: $state-none-color;
    background: $state-none-bg;
    border-radius: 2px;
  }
  @include e(status-font-3) {
    margin-left: 2px;
    // color: $state-progress-color;
    // background: $state-progress-bg;
    color: var(--state-doing-color-1);
    background: var(--state-doing-bg);
    border-radius: 2px;
  }
  @include e(status-font-4) {
    margin-left: 2px;
    color: $state-completed-color;
    background: $state-completed-bg;
  }
  @include e(status-name) {
    font-size: var(--size-font-9);
    margin-left: 6px;
    padding: 0 6px;
    height: 20px;
    line-height: 20px;
    border-radius: 10px;
    min-width: 36px;
    max-width: 70px;
  }
  @include e(add-button) {
    margin-right:  var(--m-small);
    .icontianjia {
      font-size: var(--size-font-9);
      margin-right: var(--m-mini);
    }
  }
  @include e(date) {
    justify-content: center;
  }
  @include e(due-time) {
    display: flex;
    align-items: center;
    font-size: var(--size-font-7);
  }
  ::v-deep {
    // group 行的样式，设置对齐
    @include e(cell-all-row-width) {
      padding-top: 14px;
      .vxe-cell {
        padding-left: 0;
      }
      .vxe-table--expand-btn {
        font-size: var(--size-font-5);
        color: var(--font-color-1);
      }
    }

    @include e(name-container) {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
    @include e(parent-name) {
      flex: 1;
      width: 100%;
      display: flex;
      align-items: center;
      font-size: var(--size-font-9);
      line-height: 17px;
      opacity: 0.5;
      svg {
        font-size: 12px !important;
        min-width: 12px;
        margin-right: var(--m-small);
      }
      img {
        min-width: 12px;
        margin-right: var(--m-small);
      }
      .text-ellipsis {
        flex: 1;
      }
    }
    @include e(subtask-name) {
      flex: 1;
      width: 100%;
      display: flex;
      align-items: center;
      font-size: var(--size-font-7);
      color: var(--font-color-1);
      line-height: 21px;
      svg {
        min-width: 16px;
        margin-right: var(--m-small);
      }
      img {
        min-width: 16px;
        margin-right: var(--m-small);
      }
      .text-ellipsis {
        flex: 1;
      }
      .iconcengji {
        font-size: var(--size-font-7);
        color: #e1e1e1;
        margin: -4px 2px 0 0;
      }
    }
  }
  ::v-deep {
    .vxe-body--expanded-cell {
      padding: 0 !important;
    }
    // 显示可以拖动的图标
    tr[class*="drag-drop-"]:hover {
      .iconicon_yidong {
        color: var(--font-color-2);
      }
    }
  }
}
</style>
<style lang="scss">
.zk-todo-list__todo-status {
  padding: 10px 0;
  max-width: 88px;
  .zk-todo-list__status-list {
    margin: 0;
    padding: 0;
    list-style: none;
    .zk-todo-list__status-loading {
      font-size: var(--size-font-5);
      line-height: 40px;
      text-align: center;
    }
    .zk-todo-list__status-placeholder {
      text-align: center;
    }
    .el-divider.el-divider--horizontal {
      margin: 10px 0;
      background: #EEEEEE;
    }
  }
  .zk-todo-list__status-item {
    margin: 0;
    padding: 8px 16px;
    cursor: pointer;
  }
  .zk-todo-list__status-item:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
}
.is-draggable-clone-home-table {
  display: flex;
  align-items: center;
  background: var(--main-bg-color);
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 3px 14px 2px rgba(0, 0, 0, 0.12), 0px 8px 10px 1px rgba(0, 0, 0, 0.14);
  cursor: grabbing!important;
  td{
    padding: 12px 0;
    max-width: 300px;

  }
  .zk-todo-list__title {
    cursor: grabbing!important;
  }
  .vxe-cell {
    cursor: grabbing!important;
    line-height: 26px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
    padding-left: 10px;
    padding-right: 10px;
  }
  .issue-name {
    flex: 1;
  }
  .zk-todo-list__title.zk-todo-list__name-container {
    flex-wrap: wrap;
  }
  .zk-todo-list__parent-name {
    display: flex;
    align-items: center;
    font-size: var(--size-font-9);
    line-height: 17px;
    opacity: 0.5;
    flex: 1 0 100%;
    svg {
      font-size: 12px !important;
      min-width: 12px;
      margin-right: var(--m-small);
    }
    img {
      min-width: 12px;
      margin-right: var(--m-small);
    }
    .text-ellipsis {
      flex: 1;
    }
  }
  .zk-todo-list__subtask-name {
    flex: 1;
    width: 100%;
    display: flex;
    align-items: center;
    font-size: var(--size-font-7);
    color: var(--font-color-1);
    line-height: 21px;
    svg {
      min-width: 16px;
      margin-right: var(--m-small);
    }
    img {
      min-width: 16px;
      margin-right: var(--m-small);
    }
    .text-ellipsis {
      flex: 1;
    }
    .iconcengji {
      font-size: var(--size-font-7);
      color: #e1e1e1;
      margin: -4px 2px 0 0;
    }
  }
}
</style>
